import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ProtectedRoute from './components/ProtectedRoute';
import CallbackPage from './components/CallbackPage';
import AccessDeniedPage from './components/AccessDeniedPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* OAuth callback route - handles Okta redirect */}
        <Route path="/login/callback" element={<CallbackPage />} />

        {/* Access denied page - shown when user lacks required group */}
        <Route path="/access-denied" element={<AccessDeniedPage />} />

        {/* Protected app route - requires authentication and group membership */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

